import { getDayOfYear, setDayOfYear } from 'date-fns';
import {
  format as formatDate,
  zonedTimeToUtc,
  utcToZonedTime,
} from 'date-fns-tz';

angular.module('bb.listing.open_houses').component('openHousesAdd', {
  controller: OpenHousesAddController,
  controllerAs: 'vm',
  template: require('./add.html'),
});
OpenHousesAddController.$inject = [
  '$location',
  '$rootScope',
  'BBOpenHousesService',
];

function OpenHousesAddController($location, $rootScope, BBOpenHousesService) {
  const vm = this;
  let type = 'user';
  const { role } = $rootScope.auth;
  let location = '';

  if ($rootScope.auth.isAdmin) type = 'brokerage';

  if (role === 'BRANCH_ADMIN')
    location = `?locationNum=${$rootScope.auth.location}`;

  const prepare = function () {
    const timeFrom = new Date();
    timeFrom.setHours(14);
    timeFrom.setMinutes(0);
    timeFrom.setSeconds(0);
    timeFrom.setMilliseconds(0);

    const timeTo = new Date();
    timeTo.setHours(16);
    timeTo.setMinutes(0);
    timeTo.setSeconds(0);
    timeTo.setMilliseconds(0);

    vm.openHouse = {
      type: vm.openHouseTypes[0],
      currentTime: new Date(),
      date: new Date(),
      timeFrom,
      timeTo,
    };
  };

  vm.openHouseTypes = ['public', 'agent'];

  vm.validate = () => {
    const { timeTo, timeFrom, date, currentTime } = vm.openHouse;
    if (timeTo - timeFrom === 0) {
      vm.isError = 'Start time and end time must be different';
    } else if (timeTo - timeFrom < 0) {
      vm.isError = 'End time must be after the start time';
    } else if (date - currentTime < 0) {
      vm.isError = 'Open house can not be in the past';
    } else {
      vm.isError = '';
    }
  };

  vm.search = function () {
    vm.searched = true;
    BBOpenHousesService.searchListing(type, location, vm.address).then(
      function (data) {
        vm.listings = data.listings;
      },
    );
  };

  vm.select = function (listing) {
    vm.selectedListing = listing;
    vm.timezoneStr = formatDate(
      utcToZonedTime(new Date(), listing.timezone),
      'zzz',
      {
        timeZone: listing.timezone,
      },
    );
  };

  vm.create = function () {
    const listingTimezone = vm.selectedListing.timezone;
    const dayOfYear = getDayOfYear(vm.openHouse.date);

    BBOpenHousesService.createOpenHouse(
      vm.selectedListing.id,
      vm.openHouse.type,
      zonedTimeToUtc(
        setDayOfYear(vm.openHouse.timeFrom, dayOfYear),
        listingTimezone,
      ).toISOString(),
      zonedTimeToUtc(
        setDayOfYear(vm.openHouse.timeTo, dayOfYear),
        listingTimezone,
      ).toISOString(),
    ).then(function () {
      const path = '/open_houses';
      $location.path(path);
    });
  };
  prepare();
}
